module.exports = __webpack_public_path__ + "static/media/dashboard.743bd0c3.jpg";